/**
 * @summary - Component that Provides PPM Checklist Functionality
 * @author vengateshwaran k
 * @since 2024-07-28
 */
import { Box, Stack } from "@mui/material";
import React, { useEffect, useMemo, useState,useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FemsGraph, BemsGraph, MasterGraph } from "../../utility/apiURLS";
import commonMasterRepository from '../../api/repositories/commonMasterRepository';
import PPMCheckListRepository from "../../api/repositories/ppmChecklistRepository";
import { DefaultCard } from "../../assets/styled-components/card";
import {
  getAuthToken,
  getFacilityId,
  getcompanyId,
} from "../../utility/tokenUtility";
import CloseButton from "../commoncomponents/CloseButton";
import CreateNewButton from "../commoncomponents/CreateNewButton";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import PageTitle from "../commoncomponents/PageTitle";
import RefreshExportButtons from "../commoncomponents/RefreshExportButtons";
import SectionTitle from "../commoncomponents/SectionTitle";
import { useLocation } from "react-router";
import axios from "axios";
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import PageLoader from "../commoncomponents/PageLoader";
const PpmCheckList = () => {
  const location = useLocation();
  const [rows, setRows] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deletedRowDetails, setDeletedRowDetails] = useState({});
  const navigate = useNavigate();
  const [gridApi, setGridApi] = useState({});
  const token = getAuthToken("id_token");
  const companyId = getcompanyId("companyId");
  const facilityId = getFacilityId("facilityId");
  const [errorMessage, setErrorMessage] = useState("");
  const [filterModel, setFilterModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [exportCount, setExportCount] = useState(0)
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const [serviceOptions, setServiceOptions] = useState([0]);
  const [serviceType, setServiceType] = useState();
  const runOnce = useRef(true);
  const [isLoading, setIsLoading] = useState(false);
  const accessData = useAccess();
  const access = utilities.getScreenPermissions(accessData, "ENGC002");


  const columns = serviceType?.label === 'FEMS' ? [
    { field: "femppmchecklistno", headerName: "PPM Checklist No", width: 150 },
    { field: "typecode", headerName: "Asset Type Code", width: 150 },
    { field: "typeDescription", headerName: "Asset Type Description", width: 180 },
    { field: "taskcode", headerName: "Task Code", width: 180, },
    { field: "taskdesc", headerName: "Task Code Description", width: 150 },
  ] : [
    { field: "bemppmchecklistno", headerName: "PPM Checklist No", width: 150 },
    { field: "typecode", headerName: "Asset Type Code", width: 150 },
    { field: "typeDescription", headerName: "Asset Type Description", width: 180 },
    { field: "taskcode", headerName: "Task Code", width: 180, },
    { field: "taskdesc", headerName: "Task Code Description", width: 150 },
  ];


  const fetchList = async () => {
    try {
      if (serviceType?.label === 'FEMS') {
        const ppmCheckList = await PPMCheckListRepository.getPPMChecklistList(facilityId);
        setRowCount(ppmCheckList.data.totalCount);
        setExportCount(ppmCheckList.data.totalCount);
        setRows(ppmCheckList?.data?.items)
      } else if (serviceType?.label === 'BEMS') {
        const ppmCheckList = await PPMCheckListRepository.getBemsPPMChecklistList(facilityId);
        setRowCount(ppmCheckList.data.totalCount);
        setExportCount(ppmCheckList.data.totalCount);
        setRows(ppmCheckList?.data?.items)
      }

    } catch (error) {
      console.error("Error fetching asset categories:", error);
    }
    finally{
      setIsLoading(false);
      await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work
    }
  };
  useEffect(() => {
    if(runOnce){
      setIsLoading(true);
      fetchList();
      runOnce.current=false;
    }
  }, [filterModel, sortModel, pageIndex, pageSize]);
  const handleRefresh = () => {
    setPageIndex(1);
    setPageSize(10);
    setFilterModel([])
    setSortModel([])
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const responseMasters = await commonMasterRepository.getMasters(facilityId, companyId);
        setServiceOptions(responseMasters);
      } catch (e) {
        console.log(e);
      }
    }
    fetchOptions();
  }, []);
  const serviceOptionsChange = useMemo(() => {
    try {
      setServiceType(serviceOptions?.find((item) => item?.label === 'FEMS'));
    } catch (e) {
      console.error("error fetching resource")
    }


  }, [serviceOptions]);

  const serviceChange = useMemo(() => {
    if(serviceType!=null){
      setIsLoading(true);
      fetchList();
    }
  }, [serviceType]);

  const handleCreatePPMChecklist = () => {
    navigate("register", {
      state: { service: serviceType?.label, mode: "create", rowList: rows },
    });
  };
  const fetchExportdata = async () => {

    try {
      //  let femsResponse, bemsResponse;
      // Fetch data based on the selected service (FEMS or BEMS)
      if (serviceType?.label === "FEMS") {
        const response = await axios.get(`${FemsGraph}/api/PPMChecklist/GetCommonExportPPM/${facilityId}? filterOptions=${JSON.stringify(
          filterModel
        )}&sortOptions=${JSON.stringify(sortModel)}`, config);

        setExportData(response.data)
      }
      else if (serviceType?.label === "BEMS") {
        const response = await axios.get(`${BemsGraph}/api/PPMChecklist/GetCommonExportPPM/${facilityId}? filterOptions=${JSON.stringify(
          filterModel
        )}&sortOptions=${JSON.stringify(sortModel)}`, config);
        setExportData(response.data)

      }

    } catch (error) {
      console.error("Error fetching asset categories:", error);
    }


  };
  const handleExport = () => {
  };

  const handleEdit = (rowData) => {
    navigate("register", {
      state: { ...rowData, readOnlyEdit: true, mode: "edit", service: serviceType?.label, rowList: rows },
    });
  };

  const handleView = (rowData) => {
    navigate("register", {
      state: { ...rowData, readOnly: true, mode: "view", service: serviceType?.label },
    });
  };

  const handleDelete = (row) => {
    setRowToDelete(row);
    setDeleteDialogOpen(true);
  };

  const confirmDelete = async () => {
    if (rowToDelete) {
      let id = rowToDelete?.femppmchecklistId;
      const response = serviceType?.label === "FEMS" ? await PPMCheckListRepository.removePpmCheckList(rowToDelete?.femppmchecklistId) : await PPMCheckListRepository.removeBemsPpmCheckList(rowToDelete?.bemppmchecklistId); // Use typecodeId for deletion

      if (response?.status >= 200 && response?.status <= 204)
        setDeleteDialogOpen(false);
      setConfirmationDialogOpen(true);
      setRowToDelete(null); // Clear the row to delete after deletion
      setIsLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 0)); // Allow React to render the loader before heavy work
      await fetchList();
    }
  };

  return (
    <>
        <PageLoader open={isLoading} />
      <PageTitle title={"PPM Checklist"} />
      <DefaultCard>
        <Box
          mb={1}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
          }}
        >
          <SectionTitle title="PPM Checklist" />
          <Stack direction={"row"} alignItems={"center"} gap={1}>
            <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 150 }}
              label={"Service"}
              value={serviceType}
              options={serviceOptions}
              placeholder={"Select Service"}
              highlight={true}
              onChange={(newValue) => { 
                if(newValue!=null){
                  fetchList();
                }
                setServiceType(newValue);
                 }}
            />
            {access?.canCreate && <CreateNewButton onClick={handleCreatePPMChecklist} />}
            <RefreshExportButtons
              export={rows}
              exportFunction={fetchExportdata}
              exportData={exportData}
              refData={gridApi}
              handleRefresh={handleRefresh}
              title={`PPM Checklist`}
            />
          </Stack>
        </Box>
        <CustomAgGrid
          rows={rows}
          columns={columns}
          handleEdit={access?.canEdit && handleEdit}
          handleDelete={access?.canDelete &&handleDelete}
          handleView={access?.canView &&handleView}
          setGridApi={setGridApi}
          pagination={false}
          setFilterModel={setFilterModel}
          setSortModel={setSortModel}
          totalCount={rowCount}
          pageIndex={pageIndex}
          pageSize={pageSize}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
          isLoading={isLoading}
          headerLayer={3}
        />

      </DefaultCard>
      <CloseButton />
      <CustomDialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
        onConfirm={confirmDelete}
        title="Confirmation!"
        content="Are you sure you want to delete?"
        cancelBtn="No"
        confirmBtn="Yes"
      />
      <CustomDialog
        open={confirmationDialogOpen}
        onClose={() => setConfirmationDialogOpen(false)}
        title="Deletion Successful"
        content="Record deleted successfully."
        confirmBtn="OK"
        onConfirm={() => setConfirmationDialogOpen(false)}
      />
      <CustomDialog
        open={!!errorMessage}
        onClose={() => setErrorMessage("")}
        onConfirm={() => setErrorMessage("")}
        content={errorMessage}
        confirmBtn="Ok"
      />
    </>
  );
};

export default PpmCheckList;
